import { call, put, takeLatest } from "redux-saga/effects"
import { GET_DIMENSIONS_OUTCOMES_WATCHER } from "./constants"

import {
  getDimensionsOutcomesSuccess,
  getDimensionsOutcomesFailed,
} from "./actions"
import { getDimensionsOutcomesReportApi } from "../../../../../utils/routes/routes-report"

export function* getDimensionsOutcomesSaga(action) {
  try {
    const dataStatus = action.payload
    const { data: listOutcomes } = yield call(
      getDimensionsOutcomesReportApi,
      dataStatus.params
    )
    yield put(getDimensionsOutcomesSuccess(listOutcomes))
  } catch (e) {
    yield put(getDimensionsOutcomesFailed())
  }
}

// Individual exports for testing
export default function* widgetListOutcomesSaga() {
  yield takeLatest(GET_DIMENSIONS_OUTCOMES_WATCHER, getDimensionsOutcomesSaga)
}
